<template>
    <div>
        <loading-component :value="loading"/>
        <v-form ref="form">
            <v-layout class="pa-4" wrap>
                <v-flex xs6>
                    <v-text-field label="Date" v-model="date" type="date"/>
                    <v-text-field label="Time" v-model="time" type="time"/>
                </v-flex>
                <v-flex xs6>
                    <v-text-field required
                                  :rules="[val => !!val || 'this field is required' , val => val > 0 || 'must be positive']"
                                  v-model="amount"
                                  label="Amount"/>
                    <v-select :items="on === 'CAPTAIN' ? ['Other', 'KM'] : ['Other']" label="Bonus Type"
                              v-model="type"></v-select>
                </v-flex>
                <v-flex xs6>
                    <v-select
                            :items="['CAPTAIN','PASSENGER']"
                            label="On Captain / Passenger"
                            v-model="on"
                    ></v-select>
                </v-flex>
                <v-flex xs6>
                    <choose-captains-multi
                            v-if="on === 'CAPTAIN'"
                            :multi="false"
                            label="Captain"
                            :rules="[val => !!val || 'this field is required']"
                            v-model="captain_id"
                    />
                    <choose-passenger-multi
                            v-if="on === 'PASSENGER'"
                            :multi="false"
                            label="Passenger"
                            :rules="[val => !!val || 'this field is required']"
                            v-model="passenger_id"/>
                </v-flex>

                <v-flex xs12>
                    <v-text-field label="Note(For captain)" v-model="note"/>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Details (For management)"
                                :rules="[val => !!val || 'this field is required']"
                                v-model="details"/>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-btn color="primary" round large class="title" @click="addBonus">
                    Submit
                </v-btn>
            </v-layout>
        </v-form>

    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    import moment from "moment";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";

    export default {
        name: "Bonus",
        components: {ChooseDate, ChoosePassengerMulti, ChooseCaptainsMulti, LoadingComponent},
        data() {
            return {
                loading: false,
                on: "CAPTAIN",
                note: null,
                details: null,
                amount: null,
                passenger_id: null,
                captain_id: null,
                datetime: moment().format("YYYY-MM-DD HH:mm"),
                type: 'Other'
            }
        },
        methods: {
            addBonus() {
                if (!this.$refs.form.validate())
                    return;
                this.loading = true;
                const data = Object.assign({}, this.$data);
                if (this.on === 'CAPTAIN')
                    delete data.passenger_id;
                else
                    delete data.captain_id;
                this.axios.post(this.api.ACTIONS.BONUSES_REQUEST + `?type=${this.type}`, data)
                    .then(() => {
                        return window.getApp.$emit("SHOW_TOAST", "Bonus Request has been sent and require administration approval", "green");
                    })
                    .catch(({response}) => window.getApp.$emit("SHOW_TOAST", response.data.message, "red"))
                    .finally(() => this.loading = false);
            }
        },
        computed: {
            date: {
                set(val) {
                    this.datetime = moment(val).format("YYYY-MM-DD ") + moment(this.datetime).format("HH:mm");
                },
                get() {
                    return this.datetime.split(" ")[0];
                }
            }
            ,
            time: {
                set(val) {
                    this.datetime = moment(this.datetime).format("YYYY-MM-DD ") + val
                },
                get() {
                    return this.datetime.split(" ")[1];
                }
            }
        }
        ,
    }
</script>

<style scoped>

</style>